<template>
  <div>
    <el-upload
      action=""
      ref="upload"
      :auto-upload="false"
      multiple
      :accept="accept"
      :show-file-list="true"
      :file-list="fileList"
      :limit="type === 'more' ? 9 : 1"
      :before-upload="beforeUpload"
      :on-change="onChange"
      :on-remove="onRemove"
      :on-preview="onPreview"
    >
      <el-button slot="trigger" type="primary" :loading="loading"
        >选择文件</el-button
      >
      <span v-if="$slots.default" class="upload-tip">
        <slot />
      </span>
      <!-- <div slot="tip" class="el-upload__tip">请选择上传文件</div> -->
    </el-upload>
    <pre-assets v-model="imgUrl" :appendToBod="true"></pre-assets>
  </div>
</template>

<script>
  import { buildFolder} from "../../utils";

const COS = require("cos-js-sdk-v5");
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    accept: {
      type: String,
      default: "image/*",
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      fileList: [],
      diaLoading: false,
      imgUrl: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.operationValue(val);
        } else {
          this.fileList = [];
        }
      },
    },
  },
  create() {
    this.operationValue(this.value);
  },
  methods: {
    // 舒适化配置
    init(fileObject) {
      const isLtxM = fileObject.size / 1024 / 1024 < 200;
      if (!isLtxM){
        this.$message.error('上传文件大小不能超过 200MB，请删除该文件，重新上传!');
        return
      }
      this.loading = true;
      let that = this;
      const cos = new COS({
        getAuthorization: function (options, callback) {
          that.$http({
            url: that.$http.adornUrl("/sys/config/cosConfig/toA"),
            method: "get",
          }).then(({ data }) => {
            let data1 = data.data;
            let credentials = data1 && data1.credentials;
            if (!data1 || !credentials) return console.error('credentials invalid');
            callback({
              TmpSecretId: credentials.tmpSecretId,
              TmpSecretKey: credentials.tmpSecretKey,
              XCosSecurityToken: credentials.sessionToken,
              StartTime: data1.startTime,
              ExpiredTime: data1.expiredTime,
            });
          }).catch(() => {
              this.loading = false;
          });
        }
      });
      let fileName = buildFolder("common") +  fileObject.name;
      cos.putObject(
        {
          Bucket: "mg-1303928515" /* 必须 */,
          Region: "ap-guangzhou" /* 存储桶所在地域，必须字段 */,
          Key: fileName /* 必须 */,
          StorageClass: "STANDARD",
          Body: fileObject.raw, // 上传文件对象
        },
        (err, data) => {
          this.loading = false;
          if (data && data.statusCode) {
            if (this.type === "more") {
              this.fileList = this.fileList || [];
              this.fileList.unshift({
                name: fileObject.name,
                url: "https://" + data.Location,
              });
              if (this.fileList.length > 9) {
                this.fileList = this.fileList.slice(0, 9);
              }
              const str = this.fileList.map((v) => this.getUrlValue(v.url)).join(";");
              this.$emit("input", str);
            } else {
              this.$emit("input", "https://" + this.getUrlValue(data.Location));
            }
            this.$message.success("上传成功");
          } else {
            this.$message.error("上传失败");
          }
        }
      );
    },
    operationValue(val) {
      if (!val) {
        return;
      }
      if (this.type === "more") {
        const urlArr = val.split(";");
        this.fileList = urlArr.map((v) => {
          const arr1 = v.split("/");
          const name = arr1[arr1.length - 1];
          return {
            name,
            url: v,
          };
        });
      } else {
        const arr = val.split("/");
        const name = arr[arr.length - 1];
        this.fileList = [{ url: val, name: name }];
      }
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 100;
      return isLt2M;
    },
    onChange(file) {
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M){
        this.onRemove(file,this.fileList);
        this.$message.error('上传文件大小不能超过 100MB，请删除该文件，重新上传!');
        return
      }else{
        this.init(file);
      }
    },
    onRemove(file, fileList) {
      if (this.type === "more") {
        const str = fileList.map((v) => v.url).join(";");
        this.$emit("input", str);
      } else {
        this.$emit("input", "");
      }
    },
    getUrlValue(url){
      //获取最后一个/的位置
      let site = url.lastIndexOf("/");
      //截取最后一个/后的值
      return url.substring(0, site) + "/" + decodeURIComponent(url.substring(site + 1, url.length));
    },
    onPreview(file) {
      this.diaLoading = true;
      this.imgUrl = file.url;
    },
    onCloseDia() {
      this.diaLoading = false;
      this.imgUrl = "";
    },
  },
};
</script>

<style>
.dialog {
  z-index: 100000;
}
.img {
  width: 100%;
  height: 400px;
}
</style>
